/**
 * Portal password rules that are pure text checks.
 *
 * Split out of `password.ts` only so `@repo/core/client` can re-export them
 * without dragging `better-auth/crypto` (jose + noble ciphers) into every
 * client bundle. `password.ts` re-exports everything here, so the module's
 * public surface is unchanged.
 */

export const PORTAL_PASSWORD_MIN = 10;
export const PORTAL_PASSWORD_MAX = 128;

export type PortalPasswordValidation =
	| { ok: true }
	| { ok: false; reason: "too_short" | "too_long" };

/**
 * Bounds-check a portal password the agency typed in.
 *
 * Deliberately only length: these are machine-generated by default and handed
 * to a client along with the URL, so complexity rules would only push agencies
 * toward passwords they can dictate over the phone.
 */
export function validatePortalPassword(
	input: string,
): PortalPasswordValidation {
	if (input.length < PORTAL_PASSWORD_MIN) {
		return { ok: false, reason: "too_short" };
	}
	if (input.length > PORTAL_PASSWORD_MAX) {
		return { ok: false, reason: "too_long" };
	}
	return { ok: true };
}
